import { useStoreValue } from '@core'
import { getAppContext } from 'src/context/AppContext'

export const useOrderValue = () => useStoreValue(getAppContext().order.store)

export const getOrderStore = () => getAppContext().order.store
